import { render } from "./CleaningIndex.vue?vue&type=template&id=b03bbcca"
import script from "./CleaningIndex.vue?vue&type=script&lang=js"
export * from "./CleaningIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__